// DiagiaNew — wraps the existing public DiagnosticPage with the DiagIA
// chrome so the auth context (the X-User-ID header) is carried through and
// the completed diagnostic gets saved to /api/diagia/diagnostic/save.
//
// We pass a `onComplete` callback to DiagnosticPage that runs once the LLM
// has generated the final document.

import React from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import DiagnosticPage from '../../diagnostic/DiagnosticPage';
import useDiagiaApi from '../hooks/useDiagiaApi';

export default function DiagiaNew() {
  const api = useDiagiaApi();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { identity } = useOutletContext() || {};

  // ?campaign=<id> tags the diagnostic. ?token=<invite> additionally flips
  // the matching campaign participant to "completed" once the diagnostic is
  // saved (the in-app accepted-invitation path).
  const campaignId = params.get('campaign') || null;
  const inviteToken = params.get('token') || null;

  const handleComplete = async ({ markdown, transcript, language }) => {
    if (!identity?.authenticated) return;
    try {
      const saved = await api.saveDiagnostic({
        markdown,
        transcript,
        language,
        campaignId,
        inviteToken,
      });
      console.log('DiagIA: diagnostic saved as', saved?.id, 'campaign=', campaignId);
    } catch (e) {
      console.warn('DiagIA save failed:', e);
    }
  };

  const exitTo = campaignId
    ? `/diagia/campaigns/${campaignId}`
    : '/diagia';

  return (
    <div className="dia-embed">
      <DiagnosticPage
        onComplete={handleComplete}
        embedded
        onExit={() => navigate(exitTo)}
      />
    </div>
  );
}
